import { React, useEffect, useState } from "react";

import { useDispatch } from "react-redux";

import OutsideClickHandler from "react-outside-click-handler";

import { CircularProgressBar } from "@tomik23/react-circular-progress-bar";

import Slider from "react-rangeslider";

import "react-rangeslider/lib/index.css";

import { DeleteCardModule } from "../../Modal/DeleteCard";

import {
  ApiDeletLightDefi,
  ApiLightDefiAlertUpdate,
  ApiLightDefiInvestmentRisk,
} from "../../Api";

import { EmptyCircularProgressBar } from "../EmptyCircularProgressBar";

import { NoAlertComponent } from "../../Components/NoAlert";
import { LIGHT_DEFI_INVESTMENT_RISK } from "../../Reducer/LightDefiInvestmentRisk";

import chart from "../../Assets/img/icons/chart__icon.svg";
import chart_open from "../../Assets/img/icons/chart__icon__open.svg";

import { ChartModal } from "../../Modal/Chart";

export function LightDefiCard({ element, reloadListCallback }) {
  const dispatch = useDispatch();
  const [alertvalue, setAlertValue] = useState();
  const [openProgress, setOpenProgress] = useState(false);
  const [openStake, setOpenStake] = useState(false);
  const [openUnstaking, setOpenUnstaking] = useState(false);
  const [unstakingValue, setUnstakingValue] = useState();
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  const [showAlert, setShowAlert] = useState(false);
  const [showStakeUlert, setShowStakeUlert] = useState(false);

  const [openChart, setOpenChart] = useState(false);

  const coldprops = {
    percent: Math.round(
      element?.risks?.productRisk
        ? element?.risks?.productRisk
        : element.productRisk
    ), // is require
    colorSlice: "#4DC7B5",
    fontColor: "#4DC7B5",
    fontSize: "1.625em",
    fontWeight: 900,
    size: 112,
    boxShadow: "inset 0 3px 6px rgb(0 0 0 / 16%), 0 3px 6px rgb(0 0 0 / 16%)",
    unit: "",
    textPosition: "0.35em",
    animationOff: false,
    inverse: false,
    round: true,
    number: false,
  };

  const riskprops = {
    percent: Math.round(
      element?.risks?.productRisk
        ? element?.risks?.productRisk
        : element.productRisk
    ), // is require
    colorSlice: "#EFB661",
    fontColor: "#EFB661",
    fontSize: "1.625em",
    fontWeight: 900,
    size: 112,
    boxShadow: "inset 0 3px 6px rgb(0 0 0 / 16%), 0 3px 6px rgb(0 0 0 / 16%)",
    unit: "",
    textPosition: "0.35em",
    animationOff: false,
    inverse: false,
    round: true,
    number: false,
  };

  const holdprops = {
    percent: Math.round(
      element?.risks?.productRisk
        ? element?.risks?.productRisk
        : element.productRisk
    ), // is require
    colorSlice: "#F27281",
    fontColor: "#F27281",
    fontSize: "1.625em",
    fontWeight: 900,
    size: 112,
    boxShadow: "inset 0 3px 6px rgb(0 0 0 / 16%), 0 3px 6px rgb(0 0 0 / 16%)",
    unit: "",
    textPosition: "0.35em",
    animationOff: false,
    inverse: false,
    round: true,
    number: false,
  };

  const whiteprops = {
    percent: 0, // is require
    colorSlice: "#f0f0f3",
    fontColor: "#f0f0f3",
    fontSize: "1.625em",
    fontWeight: 900,
    size: 112,
    boxShadow: "inset 0 3px 6px rgb(0 0 0 / 16%), 0 3px 6px rgb(0 0 0 / 16%)",
    unit: "",
    textPosition: "0.35em",
    animationOff: false,
    inverse: false,
    round: true,
    number: false,
  };

  const renderClassName = (color) => {
    switch (color) {
      case "green":
        return {
          className: "card cold defi",
          props: coldprops,
        };
      case "yellow":
        return {
          className: "card hold defi",
          props: riskprops,
        };
      case "red":
        return {
          className: "card risky defi",
          props: holdprops,
        };
      case "white":
        return {
          props: whiteprops,
          color: "#C4C4C4",
          className: "card empty defi",
        };
    }
  };

  const renderColorClassName = (risk) => {
    if (risk <= 100 && risk >= 80) {
      return {
        className: "card__product__number card__product__green",
      };
    } else if (risk < 80 && risk >= 60) {
      return {
        className: "card__product__number card__product__yellow",
      };
    } else if (risk < 60) {
      return {
        className: "card__product__number card__product__red",
      };
    } else if (risk === null || 0) {
      return {
        className: "card__product__number card__product__white",
      };
    }
  };

  useEffect(() => {
    setUnstakingValue(+element.autoUnstacking);
    setAlertValue(+element.alert);
  }, [element]);

  const unstakinghandleChange = (value) => {
    setUnstakingValue(value);
  };

  const handleChange = (value, e) => {
    //e.preventDefault()
    setAlertValue(value);
  };

  const alertOnChangeComplete = (value) => {
    ApiLightDefiAlertUpdate(element.id, +alertvalue)
      .then((result) => {})
      .catch((error) => {});
  };

  return (
    <>
      <div className={renderClassName(element?.risks?.trustScore)?.className}>
        <div className="card__header">
          <div className="row">
            <div
              className="chart__open__btn"
              onClick={() => {
                setOpenChart(!openChart);
              }}
            >
              {openChart ? (
                <img src={chart} alt="" className="chart__opened__btn__icon" />
              ) : (
                <img
                  src={chart_open}
                  alt=""
                  className="chart__open__btn__icon"
                />
              )}
            </div>
            <h2 className="card__title">{element.assetId?.symbol} Staking</h2>
            <div
              className="close__card__content"
              onClick={() => {
                setOpenDeleteModal(!openDeleteModal);
              }}
            >
              <span className="card__close">
                <span></span>
                <span></span>
              </span>
            </div>
          </div>
        </div>
        <div className="card__price">
          <div className="card__wallet__row">
            {/* <input className="card__wallet__rates card__wallet__rates_input" placeholder='Investment' /> */}
            <div className="card__wallet__rates">Investment</div>
          </div>
        </div>

        <div className="card__product__wrapper">
          <div className="card__product__row">
            <div
              className="card__product__title"
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "215px",
              }}
            >
              Asset:
              <div className="title_item">
                <p className="card__product__title_item">
                  {element?.assetId?.symbol}
                </p>
              </div>{" "}
            </div>
            <div
              className={
                renderColorClassName(
                  Number(Math.round(element?.risks?.assetRisk))
                    ? Number(Math.round(element?.risks?.assetRisk))
                    : Number(Math.round(element?.assetId?.value))
                    ? Number(Math.round(element?.assetId?.value))
                    : Number(Math.round(element?.assetId?.defaultValue))
                )?.className
              }
            >
              {Math.round(
                element?.risks?.assetRisk
                  ? element?.risks?.assetRisk
                  : element?.assetId?.value
                  ? element?.assetId?.value
                  : element?.assetId?.defaultValue
              )}
            </div>
          </div>

          <div className="card__product__row">
            <div
              className="card__product__title"
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "215px",
              }}
            >
              Blockchain:{" "}
              <div className="title_item">
                <p className="card__product__title_item">
                  {element?.blockchainId?.name}
                </p>
              </div>
            </div>
            <div
              className={
                renderColorClassName(
                  Number(Math.round(element?.risks?.blockchainRisk))
                    ? Number(Math.round(element?.risks?.blockchainRisk))
                    : Number(Math.round(element?.blockchainId?.value))
                    ? Number(Math.round(element?.blockchainId?.value))
                    : Number(Math.round(element?.blockchainId?.defaultValue))
                )?.className
              }
            >
              {Math.round(
                element?.blockchainId?.value
                  ? element?.blockchainId?.value
                  : element?.blockchainId?.defaultValue
              )}
            </div>
          </div>
          <div className="card__product__row">
            <div
              className="card__product__title"
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "215px",
              }}
            >
              Platform:{" "}
              <div className="title_item">
                <p className="card__product__title_item">
                  {element?.platformId?.name}
                </p>
              </div>
            </div>
            <div
              className={
                renderColorClassName(
                  Number(Math.round(element?.risk?.platformRisk))
                    ? Number(Math.round(element?.risk?.platformRisk))
                    : Number(Math.round(element?.platformId?.value))
                    ? Number(Math.round(element?.platformId?.value))
                    : Number(Math.round(element?.platformId?.defaultValue))
                )?.className
              }
            >
              {Math.round(
                element?.platformId?.value
                  ? element?.platformId?.value
                  : element?.platformId?.defaultValue
              )}
            </div>
          </div>
        </div>
        <OutsideClickHandler
          disabled={openStake ? false : true}
          onOutsideClick={(event) => {
            setOpenStake(false);
          }}
        ></OutsideClickHandler>
        <div className="card__risk" style={{ marginTop: "25px" }}>
          <h3 className="card__risk__title">Product Risk</h3>
          <div
            className={
              "card__risk__alert" +
              " " +
              (openProgress ? "active" : "card__risk__alert")
            }
            onClick={(event) => {
              if (openProgress) {
                alertOnChangeComplete();
              }
              setOpenProgress(!openProgress);
              setOpenUnstaking(false);
            }}
          >
            <p className="card__risk__alert__title">Alert</p>
            <p
              className={
                "card__risk__alert__number" +
                " " +
                (alertvalue === 0 || null
                  ? "card__risk__alert__not_number"
                  : "card__risk__alert__number")
              }
            >
              {alertvalue === null || 0 ? 0 : alertvalue}
            </p>
          </div>
          {openProgress ? (
            <div
              className={
                "card__risk__range active card__slider" +
                " " +
                (alertvalue === 0 || null
                  ? "card__slider_not_value"
                  : "card__risk__range active card__slider")
              }
            >
              <Slider
                min={0}
                max={100}
                value={alertvalue === null || 0 ? 0 : alertvalue}
                orientation="vertical"
                onChange={handleChange}
                tooltip={true}
                onChangeComplete={alertOnChangeComplete}
                step={1}
              />
            </div>
          ) : (
            ""
          )}
          {element && element?.risks?.trustScore ? (
            <div className="card__risk__chart">
              <CircularProgressBar
                {...renderClassName(element?.risks?.trustScore)?.props}
              >
                <div className="card__round__shadow"></div>
                <div className="card__risk__chart__min__wrapper">
                  <p className="card__risk__chart__number">
                    {renderClassName(element?.risks?.trustScore)?.props.percent}
                  </p>
                  <p className="card__risk__chart__number__of">of 100</p>
                </div>
              </CircularProgressBar>
            </div>
          ) : (
            <EmptyCircularProgressBar />
          )}

          <div
            className="card__risk__info"
            onClick={() => {
              setTimeout(() => {
                setShowAlert(true);
              });
              setTimeout(() => {
                setShowAlert(false);
              }, 2000);
            }}
          >
            <i className="icon-info-icon"></i>
          </div>
        </div>
      </div>
      <OutsideClickHandler
        onOutsideClick={(event) => {
          setOpenChart(false);
        }}
      >
        {openChart ? (
          <ChartModal
            element={element}
            closeModal={() => {
              setOpenChart(false);
            }}
          />
        ) : (
          ""
        )}
      </OutsideClickHandler>
      <OutsideClickHandler
        onOutsideClick={(event) => {
          setOpenDeleteModal(false);
        }}
      >
        {openDeleteModal ? (
          <DeleteCardModule
            title="You are going to delete the Investment Product"
            text="This Investment Product will be deleted, but can be restored from the Recycle Bin."
            element={element}
            deleteItem={(id) => {
              ApiDeletLightDefi(id).then((result) => {
                setOpenDeleteModal(false);
                reloadListCallback();
                ApiLightDefiInvestmentRisk()
                  .then((result) => {
                    dispatch({
                      type: LIGHT_DEFI_INVESTMENT_RISK,
                      payload: {
                        result: result.data.data,
                      },
                    });
                  })
                  .catch((error) => {});
              });
            }}
            cancel={(event) => {
              setOpenDeleteModal(event);
            }}
          />
        ) : (
          ""
        )}
      </OutsideClickHandler>

      <OutsideClickHandler
        onOutsideClick={(event) => {
          setShowAlert(false);
        }}
      >
        {showAlert ? <NoAlertComponent top={60} title={"No Alerts."} /> : ""}
      </OutsideClickHandler>

      <OutsideClickHandler
        onOutsideClick={(event) => {
          setShowStakeUlert(false);
        }}
      >
        {showStakeUlert ? (
          <NoAlertComponent
            top={60}
            title={
              "This functionality is not available for your account. Please contact LightCore."
            }
          />
        ) : (
          ""
        )}
      </OutsideClickHandler>
    </>
  );
}
